import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var ClosedEye = function ClosedEye(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#2D2D2D' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '2.2rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Hide' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 20 20",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M9.98182 4.98438C6.38909 4.98438 2.49697 8.47241 1 10.1358C2.49697 11.7991 6.40827 14.9844 10.001 14.9844C13.5937 14.9844 17.503 11.7991 19 10.1358C17.503 8.47241 13.5745 4.98438 9.98182 4.98438Z",
    stroke: color,
    strokeWidth: "0.921212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5394 9.98438C14.5394 12.4972 12.597 14.5238 10 14.5238C8.73117 14.5238 7.59738 13.8889 6.76939 12.9781C5.93579 12.0611 5.46061 10.9172 5.46061 9.98438C5.46061 9.05152 5.93579 7.9076 6.76939 6.99064C7.59738 6.07985 8.73117 5.44498 10 5.44498C11.2688 5.44498 12.4026 6.07985 13.2306 6.99064C14.0642 7.9076 14.5394 9.05152 14.5394 9.98438Z",
    stroke: color,
    strokeWidth: "0.921212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 3.5L4 16.5",
    stroke: color,
    strokeWidth: "0.92"
  }));
};

export default ClosedEye;